import { cn } from 'shared-ui';

/**
 * "FIND & FIX®" as the brand writes it: uppercase, registered mark superscripted at the
 * same size as the sidebar's. Inline, so it can sit inside a sentence or a button label —
 * keep it in the same inline run as the words around it (one span), not as a sibling flex
 * item, so they share a baseline.
 */
export function FindAndFixWordmark({ className }: { className?: string }) {
    return (
        <span className={cn('uppercase', className)}>
            Find &amp; Fix
            {/* Zero line-height stops the raised mark growing the line box (and so pushing the
                words down when the box is vertically centred); the sidebar does the same. */}
            <span className="align-super" style={{ fontSize: '1em', lineHeight: 0 }}>
                &reg;
            </span>
        </span>
    );
}
